<template>
    <div >
        <a-table :dataSource="dataSource" :pagination="this.paging==false?false:pagination" class="data_table"  @change="handleTableChange"
            :rowClassName="rowClassName"
            :class="{'lock_table':lock, 'liucun_table':liucun, 'small_table': small, 'reversescroll': topscroll}"  size="middle" id="data_table" :scroll="lock || ylen?xlen?{x:parseInt(xlen), y:ylen?ylen:400}:{y:ylen?ylen:400}:xlen?{x:parseInt(xlen)}:{}">
            <template slot="pagination" slot-scope="props">
            </template>
            <template v-for="thead in theads?theads:allfields">
                <a-table-column-group v-if="thead.children" :key="`thead${thead.id?thead.id:thead.title}`" :width="thead.width?thead.width:(lock?`${100/(theads?theads.length:fields.length)}%`:null)" :class="thead.class?`${thead.class}_th`:null">
                    <span slot="title">
                        <label v-html="thead.title"></label>
                        <a-tooltip :title="thead.desc" v-if="thead.desc && thead.id">
                            <a-icon type="question-circle" class="question" style="font-size:15px;"/>
                        </a-tooltip>
                        <!-- <a-icon type="edit" /> -->
                    </span>
                    <a-table-column :dataIndex="field.id" :key="`field${field.id}`" v-for="field in thead.children"  :align="field.align?field.align:'center'"
                        :sorter="field.sorter?(a,b)=>sorter(typeof(field.sorter)=='boolean'?field.id:field.sorter, a,b):null"
                        :defaultSortOrder="field.defaultSortOrder?field.defaultSortOrder:null"
                        :customHeaderCell="customHeaderCell"
                        :customCell="(record, rowIndex)=>customCell(thead,record,rowIndex)"
                        :style="{'justifyContent':field.align?field.align:'center'}"
                        :fixed="field.fixed"
                    >
                        <span slot="title">
                            <label v-html="field.title"></label>
                            <a-tooltip :title="field.desc" v-if="field.desc" :visible="tooltips[field.id]">
                                <a-icon type="question-circle" class="question" style="font-size:15px;"/>
                            </a-tooltip>
                            <a-tooltip title="可修改字段">
                                <a-icon type="edit" style="margin-left: 4px;" v-if="!$_.isNil(table) && field.id.indexOf(table.fields) !== -1" />
                            </a-tooltip>
                        </span>
                        <template slot-scope="text" :style="{padding:'20px'}" class="custom">
                            <div v-html="text==null || text==undefined 
                                ? '-'
                                : field.link && field.link.href? getLink(field, text)
                                : `${field.prefix?field.prefix:''}${text}${field.suffix?field.suffix:''}`"></div>
                        </template>
                    </a-table-column>
                </a-table-column-group>
                <a-table-column v-if="!thead.children" :dataIndex="thead.id" :key="`thead${thead.id}`" :align="thead.align?thead.align:thead.format?'right':'center'" :class="thead.class?`${thead.class}_th`:null"
                        :sorter="thead.sorter?(a,b)=>sorter(typeof(thead.sorter)=='boolean'?thead.id:thead.sorter, a,b):null"
                        :defaultSortOrder="thead.defaultSortOrder?thead.defaultSortOrder:null"
                    :customHeaderCell="customHeaderCell"
                    :customCell="(record, rowIndex)=>customCell(thead,record,rowIndex)"
                    :width="thead.width?thead.width:(lock?`${100/(theads?theads.length:fields.length)}%`:null)"
                    :style="{'overflow':'hidden', 'width':`${100/(theads?theads.length:fields.length)}%`}"
                        :fixed="thead.fixed"
                >
                    <span slot="title" class="th-wrap">
                        <a-tooltip :title="thead.desc" v-if="thead.desc">
                            <label v-html="thead.title"></label>
                            <a-icon type="question-circle" class="question" style="font-size:15px;"/>
                        </a-tooltip>
                        <label v-else v-html="thead.title"></label>
                        <a-tooltip title="可修改字段">
                            <a-icon type="edit" style="margin-left: 4px;" v-if="!$_.isNil(table) && thead.id.indexOf(table.fields) !== -1" />
                        </a-tooltip>
                    </span>
                    <template slot-scope="text, record, index" :style="{padding:'20px'}" class="custom">
                        <div v-if="thead.id==='_num_index'">
                            {{ index+1 }}
                        </div>
                        <div v-if="thead.id==='_remark'" style="padding:3px">
                            <a-textarea style="background:none; border:none; outline:none; resize: none;" @change="handleRemarkChange($event, record['_remark'])" v-model="remarks[record['_remark']]"></a-textarea>
                        </div>
                        <div  v-if="thead.id!=='_remark' && thead.id!=='_num_index'" v-html="text==null || text==undefined 
                            ? '-'
                            : thead.link && thead.link.href? getLink(thead, text)
                            : `${thead.prefix?thead.prefix:''}${thead.filter?format(text):thead.format?formatter(thead.format, text):text}${thead.suffix?thead.suffix:''}`"></div>
                        
                    </template>
                </a-table-column>
            </template>
        </a-table>
        <!-- <edit :show="edit.show" :data="edit.data" :field="edit.field" :id="edit.id" :name="edit.name" @close="edit.show=false" @reload="reload"></edit> -->
    </div>
</template>

<script>
import edit from '@/components/common/datatable/edit.vue'
import {Table, Tooltip, Pagination} from 'ant-design-vue';
import {numberFormat, format} from '@/utils/utils'
import Vue from 'vue'
Vue.use(Table)
Vue.use(Tooltip)

import Clipboard from 'clipboard';
import chroma from 'chroma-js'
import {sort} from '@/utils/utils'
import {isDate} from '@/utils/datetime'
import moment from "moment"
import {weekday, weekday_en} from '@/utils/utils'
import enUS from 'ant-design-vue/es/locale-provider/en_US';
import zh_CN from 'ant-design-vue/es/locale-provider/zh_CN';

const DEFAULT = ['#F0FAFF','#e6f7ff', '#DDF3FF','#C8EAFF','#B4E0FF', '#74BCFF']
const RED = ['#FFF1F0', '#FFE3E1','#FFCECA','#FFB7B7','#FFA39E', '#FF7875']
const REDGREEN = ['#FFA39E', '#FFBB96', '#FFD591', '#FFE58F', '#FFFB8F', '#EAFF8F', '#B7EB8F']
const PAGEOPTION = ['10', '20', '30', '40', '50', '100']

export default {
    components: {
        edit: edit
    },
    props:['fields', 'theads', 'datas', 'paging', 'pageSize', 'pageSizeOptions', 'liucun', "marks", "table", "color", "xlen", "ctrl", "small", "topscroll", "ylen", "show_index"],
    data() {
        return {
            lock: false,
            tooltips: {},
            pagination: {
                current: 1,
                pageSize: 10,
                pageSizeOptions: this.PAGEOPTIONALL,
                showSizeChanger: true,
                showQuickJumper: true,
                locale: this.$i18n.locale === 'en_US' ? enUS.Pagination : zh_CN.Pagination,
                showTotal: (total, range) => this.$t('dataTable.totalInfo', [total, `${range[0]}-${range[1]}`]),
                size:"middle",
                onShowSizeChange:(current, pageSize) => {
                    if(!isNaN(pageSize)) {
                        this.pagination.pageSize = pageSize
                    }
                    else {
                        this.pagination.pageSize = 0
                        this.$nextTick(()=>{this.pagination.pageSize = this.dataSource.length})
                    }
                },
                onChange:(page, pageSize) => {
                    this.pagination.current = page
                }
            },
            edit: {
                show: false,
                data: {},
                field: {},
                id: null,
                name: null
            },
            colors: {},
            remarks: {},
            PAGEOPTIONALL: ['10', '20', '30', '40', '50', '100', this.$i18n.locale === 'en_US' ? 'All' : '全部']
        }
    },
    computed: {
        dataSource() {
            let datas = []
            if(this.datas) {
                const dates = ['dt', 'ds', 'dateid', 'date']
                const down_icon = '<i class="anticon anticon-caret-down" style="color: rgb(144, 216, 108);"><svg viewBox="0 0 1024 1024" data-icon="caret-down" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"></path></svg></i>'
                const up_icon = '<i class="anticon anticon-caret-up" style="color: rgb(245, 34, 45);"><svg viewBox="0 0 1024 1024" data-icon="caret-up" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"></path></svg></i>'
                const isEn = this.$i18n.locale === 'en_US';
                this.datas.forEach((row, index)=>{                    
                    let d = Object.assign({}, row)
                    let keys = Object.keys(row)
                    d.key = index
                    dates.forEach((e) => {
                        if(keys.indexOf(e)!==-1 && (isDate(row[e], false) || isDate(row[e], true))) {
                            d[e] = row[e] + ` (${isEn ? '' : '周'}` + (isEn ? weekday_en : weekday)[moment(row[e]).weekday()] + ')'
                        }
                    })        
                    if(this.ctrl=='balance' && _.has(row, 'compare') && row.compare >0) {
                        d['compare'] = `${up_icon}<span style="display:inline-block; width:60px;">${d.compare}%</span>`
                    }
                    else if(this.ctrl=='balance' && _.has(row, 'compare') && row.compare < 0) {
                        d['compare'] = `${down_icon}<span style="display:inline-block; width:60px;">${d.compare}%</span>`
                    }
                    if(row._summary!==1 && row._summary!==true) {
                        datas.push(d)
                    }
                })
            }
            return datas
        },
        allConfig() {
            let d=this.datas
            let f=this.fields
            let t=this.theads
            this.colors = this.getColors()
            return {
                d,f,t
            }
        },
        // colors() {
        //     console.log(this.color)
        //     let color_dict = {}
        //     if(['updown', 'target'].indexOf(this.color.colorful) !== -1) {
        //         let datas = []
        //         this.datas.forEach((data, index)=> {
        //             this.fields.forEach((field)=> {
        //                 if(field.colorful && data[field.id]!=null && data[field.id]!=undefined) {
        //                     datas.push(data[field.id])
        //                 }
        //             })
        //         })
        //         if(datas) {
        //             this.color.critical=this.color.critical?this.color.critical:0
        //             datas.forEach((data, index)=>{
        //                 color_dict[data] = {
        //                     backgroundColor: this.color.colorful==='updown'? 
        //                         (data>=this.color.critical? '#fee7eb':'#e0faf8'):(data>=this.color.critical? '#e0faf8':'#fee7eb')
        //                 }
        //             })
        //             return color_dict
        //         } else {
        //             return {}
        //         }
        //     } else {
        //         // 特殊表头不做列色阶
        //         if(this.color.direct) {
        //             if(this.theads) {
        //                 return {}
        //             } else {
        //                 let datas = {}
        //                 this.fields.forEach((field, index) => {
        //                     if(field.colorful) {
        //                         datas[field.id] = []
        //                         this.datas.forEach((data, index) => {
        //                             if(data[field.id]!=null && data[field.id]!=undefined) {
        //                                 datas[field.id].push(data[field.id])
        //                             }
        //                         })
        //                     }
        //                 })
        //                 if(datas) {
        //                     _.forEach(datas, (value, key) => {
        //                         value = sort(_.uniq(value))
        //                         const radix = this.color.colorful==='default'?DEFAULT:(this.color.colorful==='red'?RED:REDGREEN)
        //                         let colors = chroma.scale(radix).colors(value.length)
        //                         value.forEach((data, index)=>{
        //                             color_dict[data] = {
        //                                 backgroundColor: colors[index],
        //                             }
        //                         })
        //                     })
        //                     return color_dict
        //                 } else {
        //                     return {}
        //                 }
        //             }
        //         } else {
        //             let datas = []
        //             if(this.theads) {
        //                 this.datas.forEach((data, index)=> {
        //                     this.theads.forEach((field) => {
        //                         if(field.colorful && data[field.id]!=null && data[field.id]!=undefined) {
        //                             datas.push(data[field.id])
        //                         }
        //                         if(field.colorful && field.children) {
        //                             field.children.forEach((child) => {
        //                                 if(data[child.id]!=null && data[child.id]!=undefined) {
        //                                     datas.push(data[[child.id]])
        //                                 }
        //                             })
        //                         }
        //                     })
        //                 })
        //             }
        //             else {
        //                 console.log(new Date(),1)
        //                 this.datas.forEach((data, index)=> {
        //                     this.fields.forEach((field)=> {
        //                         if(field.colorful && data[field.id]!=null && data[field.id]!=undefined) {
        //                             datas.push(data[field.id])
        //                         }
        //                     })
        //                 })
        //             }
        //             if(datas.length>0) {
        //                 datas = sort(_.uniq(datas))
        //                 //const radix = ['#e6f7ff', '#bae7ff', '#91d5ff', '#69c0ff', '#40a9ff', '#1890ff', '#096dd9', '#0050b3', '#003a8c', '#002766']
        //                 const radix = this.color.colorful==='default'?DEFAULT:(this.color.colorful==='red'?RED:REDGREEN)
                        
        //                 console.log(new Date(),2)
        //                 let colors = chroma.scale(radix).colors(datas.length)
        //                 datas.forEach((data, index)=>{
        //                     color_dict[data] = {
        //                         backgroundColor: colors[index],
        //                     }
        //                 })
        //                 console.log(new Date(),3)
        //                 return color_dict
        //             }
        //             else {
        //                 return {}
        //             }
        //         }
        //     }
        // },
        isMark() {
            if((_.map(this.fields, 'title')).indexOf('日期')!=-1) {
                const key = _.find(this.fields, {'title': '日期'})['id']
                if(isDate(this.datas[0][key], false)) {
                    const dates = _.map(this.datas, key)
                    let days = dates.sort().map((d, i) => {
                        let dt = new Date(d)
                        dt.setDate(dt.getDate() + 4 - i)
                        return +dt
                    })
                    return [...new Set(days)].length === 1 ? true : false
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        allfields() {
            if(this.show_index) {
                return [{id:'_num_index', title: '序号'}, ...this.fields]
            }
            return this.fields
        }
    },
    mounted() {
        if(this.pageSize === 0) {
            this.pagination = false
        }
        else {
            if(this.pageSize) {
                this.pagination.pageSize = this.pageSize
            }
            if(this.pageSizeOptions) {
                this.pagination.pageSizeOptions = this.pageSizeOptions
            }
            this.pagination.pageSizeOptions = this.datas.length > 500 ? PAGEOPTION : this.PAGEOPTIONALL
        }
        this.initTooltip()
        this.initRemark()
    },
    watch: {
        theads() {
            this.initTooltip()
            this.initRemark()
        }, 
        fields(val) {
            this.initTooltip()
            this.initRemark()
        },
        pageSize(newV) {
            if(newV) {
                this.pagination.pageSize = newV
            }
        },
        datas(newV) {
            this.pagination.current = 1
            this.pagination.pageSizeOptions = newV.length > 500 ? PAGEOPTION : this.PAGEOPTIONALL
        },
        allConfig() {
            
        }
    },
    methods: {
        format,
        formatter(style, text) {
            if(style === "num") {
                return text?text.toLocaleString():text
            }
            else if(style==="numcn"){
                return numberFormat(text)
            }
            return text
        },
        getLink(thead, text) {
            if(thead.link && thead.link.href) {
                let link = thead.link.href
                if(thead.link.key) {
                    link = `${link}${link.indexOf('?')<0?'?':'&'}${thead.link.key}=${text}`
                }
                return `<a href="${link}" target="${thead.link.target?thead.link.target:'_self'}" style="font-weight: bold; text-decoration: underline">${text}</a>`
            }
            return text
        },
        sorter(id, a, b) {
            if(typeof(a[id]) == 'number' || typeof(b[id]) == 'number')
            {
                return Number(a[id] || 0) - Number(b[id] || 0)
            } 
            else 
            {   
                return a[id] > b[id] ? 1 : a[id] < b[id] ? -1 : 0
            }
        },
        initTooltip() {
            let tooltips = {}
            if(this.theads) {
                this.theads.forEach((t)=>{
                    if(t.id) {
                        tooltips[t.id] = false
                    }
                    if(t.children) {
                        t.children.forEach((f)=>{
                            if(f.id) {
                                tooltips[f.id] = false
                            }
                        })
                    }
                })
            }
            else if(this.fields) {
                this.fields.forEach((f)=>{
                    if(f.id) {
                        tooltips[f.id] = false
                    }
                })
            }
            this.tooltips = tooltips
        },
        rowClassName(record, index) {
            // 值为0不显示背景色，record.compare可过滤0值
            if(this.ctrl && this.ctrl == 'balance' && record.compare) {
                return this.datas[index].compare >= 0 ? 'balance_up':'balance_down'
            }
        },
        customHeaderCell(cell) {
            const self = this
            return {
                on: { // 事件
                    click: () => {},       // 点击行
                    mouseenter: () => {self.tooltips[cell.dataIndex]=true},  // 鼠标移入行
                    mouseleave: () => {self.tooltips[cell.dataIndex]=false},  // 鼠标移出行
                },
            }
        },
        customCell(thead, record, rowIndex) {
            if(thead.id==='_num_index') {
                return {
                    style: {
                        background: '#f6f6f6'
                    }
                }
            }
            let text = record[thead.id]
            let cell = {}
            if(this.liucun) {
                let color = '#fff'
                if(thead.colorful && text!=null && text!=undefined) {
                    if(text<=5) {
                        color = '#FFF'
                    } else if(text<=10) {
                        color = '#F0FAFF'
                    } else if(text<=20) {
                        color = '#DDF3FF'
                    } else if(text<=30) {
                        color = '#C8EAFF'
                    } else if(text<=40) {
                        color = '#B4E0FF'
                    } else {
                        color = '#74BCFF'
                    }
                }
                cell = {
                    style: {
                        background:color, 
                    }
                }
            }
            else {
                if(thead.colorful&&text!=null) {
                    const id = typeof(thead.sorter)==='string'?thead.sorter:thead.id
                    const color = this.colors[`${thead.id}_${record[id]}`] || this.colors[text]
                    cell = {
                        style: {
                            background:color?color.backgroundColor:'#fff', 
                            color:color?color.color:'inherit'
                        }
                    }
                }
                // 特殊表头色阶
                else if(thead.colorful&&_.has(thead, 'children')) {
                    thead.children.forEach(child => {
                        text = record[child.id]
                        if(child.colorful && record[child.id] && record[child.id]!=undefined) {
                            cell = {
                                style: {
                                    background:this.colors[text].backgroundColor, 
                                    color:this.colors[text].color
                                }
                            }
                        }
                    })
                }
                else {
                    cell = {
                        style: {}
                    }
                    if(record[`_${thead.id}_color`]) {
                        cell.style.background = record[`_${thead.id}_color`]
                    }
                    else if(record['_line_color']) {
                        cell.style.background = record['_line_color']
                    }
                    if(record[`_${thead.id}_text_color`]) {
                        cell.style.color = record[`_${thead.id}_text_color`]
                    }
                    else if(record['_line_text_color']) {
                        cell.style.color = record['_line_text_color']
                    }
                }
            }
            if(thead.class) {
                cell['class'] = `${thead.class}_td`
            }
            if(this.liucun && record['dt']=='汇总') {
                cell['class'] = cell['class']?cell['class']+' summary_td':'summary_td'
            }
            // 表单修改
            if(!_.isNil(this.table) && thead['id'].indexOf(this.table.fields) !== -1) {
                let edit_field = {
                    on: {
                        click: (event) => {
                            this.edit = {
                                show: true,
                                data: record,
                                field: thead,
                                id: this.table.id,
                                name: this.table.name
                            }
                        }
                    },
                    class: { edit_td: true }
                }
                cell = Object.assign({}, edit_field, cell)
            }
            // 表单标注
            if(this.isMark && !_.isNil(this.marks) && this.marks.length > 0 && thead['title'] === '日期') {
                const key = thead['id']
                this.marks.forEach((mark, idx) => {
                    const mark_start = moment(mark.start_dt).format('YYYY-MM-DD')
                    const mark_end = moment(mark.end_dt).format('YYYY-MM-DD')
                    if(mark_start <= record[key] && record[key].split(" ")[0] <= mark_end) {
                        let dom = {
                            domProps: {
                                innerHTML: `<div class="tooltip-hook">
                                    <div style="border-bottom:2px dotted #7878ff;">${text}</div><span class="tooltip-text">${mark.text}</span></a-tooltip>`,
                            },
                            style: {
                                cursor: 'pointer',
                            }
                        }
                        cell = Object.assign({}, cell, dom)
                    }
                })
            }
            return cell
        },
        lockHeader(lock) {
            this.lock = lock
        },
        copy() {
            const data = []
            const tHeader = [];
            let fields = []
            if(this.theads) {
                this.theads.forEach((t)=>{
                    if(t.children && t.children.length>=1) {
                        t.children.forEach((f)=>{
                            let c = Object.assign({}, f)
                            c.title = `${t.title}-${c.title}`
                            fields.push(c)
                        })
                    }
                    else if(t.id) {
                        fields.push(t)
                    }
                })
            }
            else {
                fields = this.fields
            }
            fields.forEach((f)=>{
                tHeader.push(f.title)
            })
            data.push(_.join(tHeader, '\t'))
            this.datas.forEach((d)=>{
                let row = []
                fields.forEach((field)=> {
                    row.push(this.delHtmlTag(d[typeof(field.download_id)=='string'?field.download_id:typeof(field.sorter)=='string'?field.sorter:field.id], true))
                })
                data.push(_.join(row, '\t'))
            })
            const text = _.join(data, '\n')
            const clipboard = new Clipboard('#copy-btn', {
                text: () => text,
            })
            clipboard.on('success', e => {
                this.$message.success('复制成功')
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message.success('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        exportToExcel(filename) {
            const tHeader = [];
            let fields = []
            if(this.theads) {
                this.theads.forEach((t)=>{
                    if(t.children && t.children.length>=1) {
                        t.children.forEach((f)=>{
                            let c = Object.assign({}, f)
                            c.title = `${t.title}-${c.title}`
                            fields.push(c)
                        })
                    }
                    else if(t.id) {
                        fields.push(t)
                    }
                })
            }
            else {
                fields = this.fields
            }
            fields.forEach((f)=>{
                tHeader.push(this.delHtmlTag(f.title))
            })
            const data = [tHeader]
            if(this.datas) {
                this.datas.forEach((d)=>{
                    let row = []
                    fields.forEach((field)=> {
                        let v = this.delHtmlTag(d[field.download_id?field.download_id:typeof(field.sorter)=='string'?field.sorter:field.id])
                        row.push(v)
                    })
                    data.push(row)
                })
            }
            let text = []
            data.forEach((row)=>{
                text.push(row.join(','))
            })
            const link = document.createElement('a')
            link.download = `${filename?filename:'数据'}.csv`
            link.href = this.getDownloadUrl(text.join('\n'))
            const evObj = new MouseEvent('click', { view: window, bubbles: true, cancelable: true })
            link.dispatchEvent(evObj)
        },
        delHtmlTag(str, copy) {
            if(typeof(str) == "string") {
                str = str.replace('<br />', '\r\n')
                str = str.replace('<br/>', '\r\n')
                str = str.replace('<br>', '\r\n')
                str = str.replaceAll("\"", "\"\"")
                return `"${str.replace(/<[^>]+>/g,"")}"`
            }
            return str
        },
        getDownloadUrl(text) {
            const BOM = '\uFEFF'
            // Add BOM to text for open in excel correctly
            if (window.Blob && window.URL && window.URL.createObjectURL) {
                const csvData = new Blob([BOM + text], { type: 'text/csv;charset=utf-8;' })
                return URL.createObjectURL(csvData)
            }
            return `data:text/csv;charset=utf-8,${BOM}${encodeURIComponent(text)}`
        },
        reload(val) {
            this.datas.forEach((e) => {
                if(e[this.edit.id] === this.edit.data[this.edit.id]) {
                    e[this.edit.field.id] = val
                }
            })
        },
        handleTableChange(pagination, filters, sorter) {
            this.$emit('update:config', {pagination:pagination.props, sorter:sorter.field?{field:sorter.field, order:sorter.order}:undefined})
        },
        getColors() {
            let color_dict = {}
            let this_color = this.color?this.color:{}
            if(['updown', 'target'].indexOf(this_color.colorful) !== -1) {
                let datas = []
                this.datas.forEach((data, index)=> {
                    this.fields.forEach((field)=> {
                        if(field.colorful && data[field.id]!=null && data[field.id]!=undefined) {
                            datas.push(data[field.id])
                        }
                    })
                })
                if(datas) {
                    this_color.critical=this_color.critical?this_color.critical:0
                    datas.forEach((data, index)=>{
                        color_dict[data] = {
                            backgroundColor: this_color.colorful==='updown'? 
                                (data>=this_color.critical? '#fee7eb':'#e0faf8'):(data>=this_color.critical? '#e0faf8':'#fee7eb')
                        }
                    })
                    return color_dict
                } else {
                    return {}
                }
            } else {
                // 特殊表头不做列色阶
                if(this_color.direct) {
                    if(this.theads) {
                        return {}
                    } else {
                        let datas = {}
                        this.fields.forEach((field, index) => {
                            if(field.colorful) {
                                datas[field.id] = []
                                this.datas.forEach((data, index) => {
                                    const id = typeof(field.sorter) === 'string' ? field.sorter : field.id
                                    if(data[id]!=null && data[id]!=undefined) {
                                        datas[field.id].push(data[id])
                                    }
                                })
                            }
                        })
                        this.fields.forEach((field, index) => {
                            if(field.colorful && datas[field.id]) {
                                const value = sort(_.uniq(datas[field.id]))
                                const radix = this_color.colorful==='default'?DEFAULT:(this_color.colorful==='red'?RED:REDGREEN)
                                let colors = chroma.scale(radix).colors(value.length)
                                value.forEach((data, index)=>{
                                    color_dict[`${field.id}_${data}`] = {
                                        backgroundColor: colors[index],
                                    }
                                })
                            }
                        })
                        return color_dict
                    }
                } else {
                    let datas = []
                    if(this.theads) {
                        this.datas.forEach((data, index)=> {
                            this.theads.forEach((field) => {
                                if(field.colorful && data[field.id]!=null && data[field.id]!=undefined) {
                                    datas.push(data[field.id])
                                }
                                if(field.colorful && field.children) {
                                    field.children.forEach((child) => {
                                        if(data[child.id]!=null && data[child.id]!=undefined) {
                                            datas.push(data[[child.id]])
                                        }
                                    })
                                }
                            })
                        })
                    }
                    else {
                        this.datas.forEach((data, index)=> {
                            this.fields.forEach((field)=> {
                                if(field.colorful && data[field.id]!=null && data[field.id]!=undefined) {
                                    datas.push(data[field.id])
                                }
                            })
                        })
                    }
                    if(datas.length>0) {
                        datas = sort(_.uniq(datas))
                        //const radix = ['#e6f7ff', '#bae7ff', '#91d5ff', '#69c0ff', '#40a9ff', '#1890ff', '#096dd9', '#0050b3', '#003a8c', '#002766']
                        const radix = this_color.colorful==='default'?DEFAULT:(this_color.colorful==='red'?RED:REDGREEN)
                        
                        let colors = chroma.scale(radix).colors(datas.length)
                        datas.forEach((data, index)=>{
                            color_dict[data] = {
                                backgroundColor: colors[index],
                            }
                        })
                        return color_dict
                    }
                    else {
                        return {}
                    }
                }
            }
        },
        handleRemarkChange: _.debounce(function(e, key) {
            this.$service.addData(`${this.$service.api.project.remark}${this.$route.query.id}/remarks/`, {key, content: e.target.value}).then((data) => {
            })
        }, 200),
        initRemark() {
            
            let _remark_flag = false
            this.fields.forEach(f=>{
                if(f.id == '_remark') {
                    _remark_flag = true
                }
            })
            if(_remark_flag) {
                this.$service.getData(`${this.$service.api.project.remark}${this.$route.query.id}/remarks/`).then((data) => {
                    const remark_dict = {}
                    data.forEach(d=>{
                        remark_dict[d['key']] = d['content']
                    })
                    this.remarks = remark_dict
                })
            }
            else {
                this.remark = {}
            }
        }
    },
}
</script>
<style lang="less">
.th-wrap {
    position: relative;
}
.data_table .ant-table {
    overflow:auto
}
.data_table .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td{
    padding:0;
    & > div {
        padding: 16px 16px;
    }
}
.data_table.lock_table .ant-table-tbody  tr  td{
    word-break: break-all;
}

.data_table .ant-table-pagination.ant-pagination {
    width:100%;
    text-align: right;
}
.data_table .ant-pagination-options{
    text-align: center;
}
.data_table .ant-pagination-total-text {
    float:left;
    color:#999;
}
.data_table .ant-table-placeholder {
    padding:50px 0;
}
.ant-table-thead {
    border: 1px solid #e8e8e8;
    border-radius: 10px 10px 10px 10px;
}
.ant-table-thead > tr > th{
    font-weight: bold;
    text-align: center;
}
.ant-table-tbody > tr > td{
    text-align: center;
}
.ant-pagination-item-active {
    background: #1890ff;
    color: #fff;
    a {
        color: #fff;
    }
    &:hover, &:focus {
        a {
            color: #fff;
        }
    }
}

.lock {
    overflow: auto;
    overflow-x: hidden;
    .ant-table-thead{
        display: block;
    }
    .ant-table-tbody {
        display: block;
        max-height: 400px; overflow-y: scroll;
    }
}
.balance_up {
    background: #fee7eb;
}

.balance_down {
    background: #e0faf8;
}



.data_table.small_table .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td.nopadding_td{
    padding:0;
    & > div {
        padding: 0;
    }
}

.data_table.liucun_table  .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td > div,
.data_table.small_table  .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td > div {
    padding:6px;
}
.data_table.liucun_table  .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th, 
.data_table.small_table  .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
    padding:12px 0px !important;
}
.ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters {
    padding-right:8px !important;
}
.ant-table-thead > tr > th .ant-table-column-sorters {
    display: flex;
    align-items: center;
    justify-content: center;
    span {
        vertical-align: top;
    }
    .ant-table-column-sorter {
        position:relative;
        display: inline-block;
        vertical-align: top;
        top:auto;
        margin: 0 0 0 5px;
        right:0;
    }
}
.ant-table-thead > tr > th.ant-table-align-left .ant-table-column-sorters {
    justify-content: left;
}.ant-table-thead > tr > th.ant-table-align-right .ant-table-column-sorters {
    justify-content: right;
}
.edit_td {
    cursor: pointer;
    font-weight: 600;
    &:hover {
        color: #7878ff;
    }
}
.tooltip-hook {
    position: relative;
    display: inline-block;
}
.tooltip-hook .tooltip-text {
    visibility: hidden;
    background: #7171ff;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 5px;
    position: absolute;
    bottom: 80%;
    left: -15%;
    right: -15%;
    // right: 30%;
    // margin-left: -100px;
    z-index: 99;
    opacity: 0;
    transition: opacity 1s;
}
.tooltip-hook .tooltip-text:after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #7171ff transparent transparent transparent;
}
.tooltip-hook:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}

.reversescroll {
    .ant-table-scroll {
        .ant-table-header {
            transform: scaleY(-1);
        }
        .ant-table-body {
            transform: scaleY(-1);
        }
        .ant-table-fixed {
            transform: scaleY(-1);
        }
    }
    .ant-table-fixed-left {
        margin: 17px 0 0 0;
    }

    .ant-table-fixed-header {
        
        .ant-table-scroll {
            .ant-table-fixed {
                transform: none;
            }
            .ant-table-body {
                transform: none;
                overflow-y: scroll;
                overflow-x: hidden;
            }
            .ant-table-header {
                transform: scaleY(-1);
                .ant-table-fixed {
                    transform: scaleY(-1);
                }
            }
        }
        .ant-table-fixed-left {
            margin: 0;
        }

    }
}


</style>
